/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs */

const en__field_enum_karl_theodor_von_dalberg_gymnasium4 = /** @type {(inputs: _Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field_enum_karl_theodor_von_dalberg_gymnasium4 = /** @type {(inputs: _Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karl-Theodor-von-Dalberg-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_karl_theodor_von_dalberg_gymnasium4 = /** @type {((inputs?: _Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Karl_Theodor_Von_Dalberg_Gymnasium4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_karl_theodor_von_dalberg_gymnasium4(inputs)
	return de__field_enum_karl_theodor_von_dalberg_gymnasium4(inputs)
});
export { _field_enum_karl_theodor_von_dalberg_gymnasium4 as "_field_enum_Karl_Theodor_von_Dalberg_Gymnasium" }